import { QueryClient } from 'react-query';
import config from 'config';

export let queryClient: QueryClient;
export const initClient = (): void => {
    queryClient = new QueryClient({ defaultOptions: { queries: config.query } });
};
